<template>
  <div v-click-outside="close">
    <slot>
      <div>
        <slot name="label" v-bind="{ toggle, isOpen }" />
      </div>
      <div v-if="isOpen" class="absolute z-50">
        <slot name="menu-content" v-bind="{ toggle, close }" />
      </div>
    </slot>
  </div>
</template>

<script lang="ts">
import ClickOutside from 'vue-click-outside'

export default defineComponent({
  name: 'UiMenu',
  directives: {
    ClickOutside,
  },
  setup() {
    const isOpen = ref(false)

    return {
      isOpen,
      close: () => (isOpen.value = false),
      toggle: () => (isOpen.value = !isOpen.value),
    }
  },
})
</script>
